import TimeRangeButton from "common/Buttons/TimeRangeButton";
import { TIME_RANGE_START } from "common/constants";
import FlagOutlined from "@ant-design/icons/FlagOutlined";
import { BASE_CHART_TIME_RANGES } from "@shared/common/constants";
import styled, { useTheme } from "styled-components";
import { Flag } from "lucide-react";

const ChartTimeRangeButtons = ({
  timeRanges,
  selectedTimeRange,
  handleSelectTimeRange,
  additionalButtons,
  buttonSize,
  buttonType,
}) => {
  const { isNewLook } = useTheme();
  const type = buttonType ?? "primary";
  const ranges = timeRanges || BASE_CHART_TIME_RANGES;

  // The new look shows the ranges as one quiet segmented track.
  if (isNewLook) {
    return (
      <>
        {additionalButtons}
        <NewLookTrack role="group">
          {ranges.map((timeRange) => {
            const isStartTimeRange = timeRange === TIME_RANGE_START;
            const isSelected = timeRange === selectedTimeRange;
            return (
              <NewLookRange
                type="button"
                key={timeRange}
                aria-pressed={isSelected}
                $selected={isSelected}
                onClick={() => handleSelectTimeRange(timeRange)}
              >
                {isStartTimeRange ? (
                  <Flag size={13} strokeWidth={1.75} />
                ) : (
                  timeRange
                )}
              </NewLookRange>
            );
          })}
        </NewLookTrack>
      </>
    );
  }

  return (
    <>
      {additionalButtons}
      {ranges.map((timeRange) => {
        const isStartTimeRange = timeRange === TIME_RANGE_START;
        return (
          <TimeRangeButton
            onClick={() => handleSelectTimeRange(timeRange)}
            type={type}
            selected={timeRange === selectedTimeRange}
            key={timeRange}
            $size={buttonSize}
            icon={isStartTimeRange ? <FlagOutlined /> : null}
          >
            {!isStartTimeRange && timeRange}
          </TimeRangeButton>
        );
      })}
    </>
  );
};

export default ChartTimeRangeButtons;

const NewLookTrack = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 2px;
  padding: 2px;
  border-radius: 999px;
  background: ${(p) => p.theme.colors.cardLightBgColor};
  box-shadow: inset 0 0 0 1px ${(p) => p.theme.colors.lightestBorderGrey};
`;
const NewLookRange = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 30px;
  height: 24px;
  padding: 0 8px;
  border: 0;
  border-radius: 999px;
  background: ${(p) =>
    p.$selected ? p.theme.colors.cardBgColor : "transparent"};
  box-shadow: ${(p) =>
    p.$selected ? "0 1px 2px rgba(13, 20, 78, 0.1)" : "none"};
  color: ${(p) =>
    p.$selected ? p.theme.colors.titleColor : p.theme.colors.secondaryText};
  font: inherit;
  font-size: 12.5px;
  font-weight: ${(p) =>
    p.$selected
      ? p.theme.typography.fontWeights.SEMI_BOLD
      : p.theme.typography.fontWeights.MEDIUM};
  cursor: pointer;
  transition: background-color 150ms, color 150ms;
  &:hover {
    color: ${(p) => p.theme.colors.titleColor};
  }
  &:focus-visible {
    outline: 2px solid ${(p) => p.theme.colors.primaryBlue};
    outline-offset: 1px;
  }
`;
